"use client";
import RichText from "@components/TextEditor";
import { OnboardingPage, VeDrawer } from "@packages/ui/components";
import { toast } from "@libs/helper/toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSession } from "next-auth/react";
import { getDirtyValues } from "@libs/helper";
import { mutateAction } from "@libs/actions/mutateAction";
import { DynamicImage } from "@libs/helper/DynamicImage";
import {
  ADD_BLUE_ICON,
  FILE,
  PDF,
  UPLOAD_BLUE_ICON,
  UPLOAD_ICON,
} from "@public/index";
import { fileTypeImages } from "@libs/helper/fileTypeImages";
import { getFileTypeImage } from "@libs/helper/fileTypeImages";
import { usePathname, useRouter } from "next/navigation";
import useQueryData from "@libs/customHooks/useQueryData";
import { useData } from "@providers/context";
import { timeZoneDateTimeUser } from "@components/TimeZoneFormatUser/timeZoneFormatUser";
import { useMediaQuery } from "@packages/ui/mui";

const OnboardingPageDrawer = ({
  isOpen,
  onClose,
  projectId,
  projectData,
  projectLoading,
  projectRefetch,
  documentsRefetch,
  fromProjects,
}: any) => {
  const { userData, configData } = useData();
  return (
    <VeDrawer isOpen={isOpen} side={"bottom"} fullWidth topRadius>
      {isOpen && (
        <OnboardingPage
          assets={{
            add: ADD_BLUE_ICON,
            upload: UPLOAD_BLUE_ICON,
            file: FILE,
            pdf: PDF,
            uploadVariant: UPLOAD_ICON,
            isOpen: isOpen,
          }}
          variables={{
            bucketType: process.env.NEXT_PUBLIC_BUCKET_FILES,
            uploadFiles: mutateAction,
            useQueryData: useQueryData,
            fileTypeImages: fileTypeImages,
            userData: userData,
            useMutation: useMutation,
            toast: toast,
            useSession: useSession,
            getFileTypeImage: getFileTypeImage,
            projectRefetch: projectRefetch,
            documentsRefetch: documentsRefetch,
            fromProjects,
            useMediaQuery: useMediaQuery,
            configData: configData
          }}
          projectData={projectData}
          projectLoading={projectLoading}
          fileTypeImages={fileTypeImages}
          DynamicImage={DynamicImage}
          RichText={RichText}
          toast={toast}
          useMutation={useMutation}
          useQueryClient={useQueryClient}
          useQueryData={useQueryData}
          useSession={useSession}
          getDirtyValues={getDirtyValues}
          mutateAction={mutateAction}
          getFileTypeImage={getFileTypeImage}
          onClose={onClose}
          usePathname={usePathname}
          timeZoneDateTimeUser={timeZoneDateTimeUser}
          projectId={projectId}
          useRouter={useRouter}
        />
      )}
    </VeDrawer>
  );
};

export default OnboardingPageDrawer;
